// react and mui stuff
import CircularProgress from "@mui/joy/CircularProgress";

export default function Loading() {
  return (
    <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", gridColumn: "1/3" }}>
      <CircularProgress size='lg'/>
    </div>
  )
}